import { supabase } from './supabase';

export type FormSubmissionStatus = 'new' | 'completed' | 'archived';
export type FormSubmissionType = 'contact' | 'questionnaire';

export type FormSubmission = {
  id: string;
  created_at: string;
  updated_at: string;
  form_type: FormSubmissionType;
  csv_line: string;
  status: FormSubmissionStatus;
  completed_at: string | null;
  archived_at: string | null;
};

export async function listFormSubmissions(): Promise<FormSubmission[]> {
  const { data, error } = await supabase
    .from('form_submissions')
    .select('id, created_at, updated_at, form_type, csv_line, status, completed_at, archived_at')
    .order('created_at', { ascending: false });
  if (error) throw new Error(error.message);
  return (data ?? []) as FormSubmission[];
}

export async function updateFormSubmissionStatus(
  submissionId: string,
  status: FormSubmissionStatus,
): Promise<FormSubmission> {
  const { data, error } = await supabase
    .from('form_submissions')
    .update({ status })
    .eq('id', submissionId)
    .select('id, created_at, updated_at, form_type, csv_line, status, completed_at, archived_at')
    .single();
  if (error) throw new Error(error.message);
  return data as FormSubmission;
}
